import { InternalTransportGate } from "./internalTransport.types";

export const INTERNAL_TRANSPORT_GATE_CONFIG: Record<
  InternalTransportGate,
  {
    gateIdKey: "farmGateId" | "processGateId";
    missingGateError: string;
    deleteTitle: string;
    deleteSubtitle: string;
  }
> = {
  farm: {
    gateIdKey: "farmGateId",
    missingGateError: "Please create cultivation before create internal transportation",
    deleteTitle: "Delete Farm Gate Internal Transport",
    deleteSubtitle:
      "Are you sure you want to remove the farm gate internal transport? Please consider you cannot recover these data after removed"
  },
  process: {
    gateIdKey: "processGateId",
    missingGateError: "Please create Process Gate before create internal transportation",
    deleteTitle: "Delete Process Gate Internal Transport",
    deleteSubtitle:
      "Are you sure you want to remove the process gate internal transport? Please consider you cannot recover these data after removed"
  }
};
